import {useState, useEffect} from "react";
import {BasicDropdown} from "components/Dropdown";
import {useListCashierUnit} from "hooks/AdminHospital/Medicine";

export function InputUnit(props) {
	const {data: dataUnitObat} = useListCashierUnit({
		medicineId: props.medicineId,
		hospitalId: props.hospitalId,
		sortBy: "title.asc",
	});
	const [unitObatOptions, setUnitObatOptions] = useState([]);

	useEffect(() => {
		if (dataUnitObat?.success) {
			setUnitObatOptions([
				{label: "-", value: null},
				...(dataUnitObat.data.rows.map(item => ({label: item.title, value: item.id, objectData: item})) || []),
			]);
		}
	}, [dataUnitObat]);

	return (
		<BasicDropdown
			className={"form-control"}
			data={unitObatOptions}
			name={props.name}
			returnObject={true}
			value={props.value}
			onSelect={props.onSelect}
		/>
	);
}
